import { __decorate } from "tslib";
import { mixins } from 'vue-class-component';
import { Component } from 'vue-property-decorator';
import PaymentOptionFormMixin from '@/helpers/vue_mixins/v2/PaymentOptionFormMixin';
import RouterParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
import ActionButton from '@/components/action_button/Index.vue';
import FormHeader from '@/components/v2/FormHeader.vue';
import BaseTextField from '@/components/v2/BaseTextField.vue';
import CreateThirdPartyApiSetting from '@/plugins/graphql/mutations/v2/third-party-api-setting-create.gql';
import UpdateThirdPartyApiSetting from '@/plugins/graphql/mutations/v2/third-party-api-setting-update.gql';
import { required } from 'vuelidate/lib/validators';
import { successfulUpdate, successfulCreate } from '@/helpers/mixins/LocalizationHelper';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import CleverTapEventsMixin from '@/helpers/vue_mixins/v3/CleverTapEventsMixin';
let PaymentOptionFormCreditCard = class PaymentOptionFormCreditCard extends mixins(PaymentOptionFormMixin, RouterParamsAppMixin, ViewportSizeMixin, CleverTapEventsMixin) {
    constructor() {
        super(...arguments);
        this.paymentDetails = 'Payment Details';
        this.form = {
            paymentName: null,
            apiPublicKey: '',
            apiSecretKey: '',
        };
    }
    onSubmit() {
        this.$v.$touch();
        if (!this.$v.$invalid) {
            this.submit();
        }
    }
    async submit() {
        this.requestOnFlight();
        const mutation = () => {
            const provider = this.paymentGateway.appPaymentProvider;
            if (provider) {
                return this.sendUpdateMutation(provider.uuid);
            }
            return this.sendCreateMutation();
        };
        await mutation()
            .catch((e) => {
            this.errorNotification(e.message);
        })
            .finally(() => {
            this.requestDone();
        });
    }
    async sendCreateMutation() {
        return this.create().then(() => {
            const msg = successfulCreate(this.label);
            this.paymentManagerAction('SUBMIT CREATE', this.form.paymentName);
            this.successNotification(msg);
            this.success();
        });
    }
    async sendUpdateMutation(providerUuid) {
        return this.update(providerUuid).then(() => {
            const msg = successfulUpdate(this.label);
            this.paymentManagerAction('SUBMIT EDIT', this.form.paymentName);
            this.successNotification(msg);
            this.success();
        });
    }
    async create() {
        const vm = this;
        const paymentGatewayUuid = this.paymentGateway.uuid;
        return this.$apollo.mutate({
            mutation: CreateThirdPartyApiSetting,
            variables: {
                input: {
                    appUuid: this.appUUID,
                    apiPublicKey: this.form.apiPublicKey,
                    apiSecretKey: this.form.apiSecretKey,
                    provider: this.paymentGateway.title.toLowerCase(),
                },
            },
            update(cache, { data }) {
                vm.syncPaymentGatewayCache(cache, data.paymentOptionCreate.option, paymentGatewayUuid);
            },
        });
    }
    async update(providerUuid) {
        return this.$apollo.mutate({
            mutation: UpdateThirdPartyApiSetting,
            variables: {
                input: {
                    thirdPartyApiSettingUuid: providerUuid,
                    apiPublicKey: this.form.apiPublicKey,
                    apiSecretKey: this.form.apiSecretKey,
                },
            },
        });
    }
    mounted() {
        if (this.paymentGateway) {
            const gateway = this.paymentGateway;
            this.form = {
                paymentName: this.paymentGateway.title,
                apiPublicKey: gateway?.appPaymentProvider?.apiPublicKey,
                apiSecretKey: gateway?.appPaymentProvider?.apiSecretKey,
            };
        }
    }
};
PaymentOptionFormCreditCard = __decorate([
    Component({
        components: {
            ActionButton,
            BaseTextField,
            FormHeader,
        },
        validations: {
            form: {
                apiPublicKey: {
                    required,
                },
                apiSecretKey: {
                    required,
                },
            },
        },
    })
], PaymentOptionFormCreditCard);
export default PaymentOptionFormCreditCard;
